/**
 * 业务层 pending 信号识别包装。
 * 与 finance 后端约定：res.code === 1 && res.errorCode === 'staff_pending' 即代表 Staff 异步创建中。
 *
 * 用法：
 *   const { pending, res } = await withPendingHandle(() => httpRequest.get('/...'));
 *   if (pending) { ... show skeleton, polling ... }
 *   else if (res.code === 0) { ...consume res.data... }
 *   else { ...other business error... }
 *
 * 不走 axios 全局拦截器，避免误拦其他业务 code===1 错误。
 *
 * @param {() => Promise<any>} apiCall 一个发起请求的函数，返回 ResponseMO 形态的 Promise
 * @returns {Promise<{pending: boolean, res?: any, error?: any}>}
 */
export const withPendingHandle = async (apiCall) => {
  try {
    const res = await apiCall();
    if (res && res.code === 1 && res.errorCode === 'staff_pending') {
      return { pending: true, res };
    }
    return { pending: false, res };
  } catch (error) {
    return { pending: false, error };
  }
};

export default withPendingHandle;
